import { palette } from './palette';
import background from 'assets/images/faq-banner-img.webp';
import testimonialBg from 'assets/images/testimonialBg.webp';
import YesIcon from 'assets/images/yes-icon.svg';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.smartyplans-consumer-portal-container, .smartyplans-consumer-portal-container': {
    '& .MuiTypography-root': {
      fontFamily: 'Fredoka',
    },
    '& .header-phone-link': {
      display: 'none',
    },
    '& .menu-item--no-dropdown': {
      alignItems: 'center',
      display: 'flex',
      gap: 20,
    },
    '& .topbar-list .menu-item, & .topbar-list .MuiTypography-root': {
      color: palette.text.title,
      fontSize: 16,
      letterSpacing: '-0.32px',
      lineHeight: '20px',
    },
    '& .topbar-signup-cta': {
      background: palette.background.header,
      borderRadius: 12,
      color: palette.text.highlight,
      fontSize: 16,
      letterSpacing: '-0.32px',
      padding: '12px 20px',
      textTransform: 'none',
    },
    '& .topbar-secondary-cta': {
      background: palette.text.highlight,
      border: `1px solid ${palette.background.header}`,
      borderRadius: 12,
      color: palette.background.header,
      fontSize: 16,
      letterSpacing: '-0.32px',
      padding: '12px 20px',
      textTransform: 'none',
    },
    '& .app-main-box': {
      background: palette.background.light
    },
    '& .normal-text': {
      fontWeight: 300,
    },
    '& .MuiButton-sizeLarge': {
      fontSize: '16px !important',
      lineHeight: '20px',
      padding: '12px 24px !important',
    },
    '& .hero-link-button.MuiButton-root, & .login-button.MuiButton-root': {
      fontSize: '16px !important',
      fontWeight: 400,
      letterSpacing: '-0.32px',
      lineHeight: '20px',
      padding: '12px 24px !important',
    },
    '& .app-main-content': {
      paddingTop: 104,

      '@media screen and (max-width: 900px)': {
        paddingTop: 72,
      },
    },
    '& .header-wrapper': {
      '& .MuiToolbar-root': {
        minHeight: 104,
        paddingLeft: 42,
        paddingRight: 42,

        '@media screen and (max-width: 900px)': {
          minHeight: 72,
          paddingLeft: 20,
          paddingRight: 20,
        },
      },
      '& .top-bar-logo-container': {
        height: 56,
      },
      '& .top-bar-logo-container .image': {
        height: '56px',
        width: 'auto',
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section, .faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        marginTop: '64px',
        background: palette.background.header,
        '& .hero-header-title': {
          color: palette.text.highlight,
        },
        '& .hero-header-subtitle': {
          color: palette.text.highlight,
        },
      },

    '& .dashboard-hero-section .hero-header-title': {
      color: `${palette.text.highlight} !important`,
    },

    '& .checkout-outer-container, .plan-selection-container': {
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      backgroundColor: palette.background.hero,

      '& .hero-background': {
        objectFit: 'cover',
        '@media screen and (max-width: 900px)': {
          height: '340px',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '680px',
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
        },
      },
      '&.home-hero-variant-3': {
        paddingBottom: 0,
        '& .hero-image-side': {
          overflow: 'visible',
        },
        '& .hero-split-image': {
          height: 'calc(100% - 68px)',
          left: -42,
          objectFit: 'contain',
          objectPosition: 'left center',
          top: 18,
          width: 'calc(100% + 24px)',
        },
        '@media screen and (max-width: 900px)': {
          paddingBottom: 0,
          '& .hero-content-side': {
            alignItems: 'flex-start',
            textAlign: 'start',
          },
          '& .section-header, & .section-header__title, & .section-header__subtitle':
            {
              textAlign: 'start',
            },
          '& .section-header__title, & .section-header__subtitle': {
            marginLeft: 0,
            marginRight: 'auto',
          },
          '& .section-header__cta-wrapper': {
            justifyContent: 'flex-start',
            marginLeft: 0,
            marginRight: 'auto',
          },
          '& .section-header__cta-container': {
            justifyContent: 'flex-start',
            marginLeft: 0,
            marginRight: 'auto',
          },
          '& .section-header__cta-item-wrapper': {
            display: 'flex',
            justifyContent: 'flex-start',
            width: '100%',
          },
          '& .hero-image-side': {
            display: 'flex',
            justifyContent: 'center',
          },
          '& .hero-split-image': {
            height: '100%',
            left: 0,
            objectPosition: 'center center',
            top: 0,
            width: '100%',
          },
        },
      },
      '& .home-hero-title': {
        color: palette.text.primary,
        fontSize: '64px',
        letterSpacing: '-3.2px',
        lineHeight: '72px',
        marginBottom: '24px',
      },
      '& .home-hero-pretitle': {
        color: palette.text.primary,
        fontSize: '24px',
        fontWeight: 500,
        letterSpacing: '-0.96px',
        lineHeight: '28px',
        marginBottom: '24px',
      },
      '& .home-hero-pretitle span, & .home-hero-title span': {
        color: palette.primary.main,
        fontWeight: 'inherit',
      },
      '& .home-hero-pretitle span': {
        marginLeft: '0.25em',
      },
      '@media screen and (max-width: 768px)': {
        '& .home-hero-title': {
          fontSize: '40px',
          letterSpacing: '-1.6px',
          lineHeight: '48px',
          marginBottom: '8px',
        },

        '& .home-hero-pretitle': {
          marginBottom: '8px',
        },

        '& .section-header__subtitle-wrapper .home-hero-subtitle': {
          marginBottom: '8px',
        },

        '& .section-header__cta-wrapper': {
          marginTop: '8px',
        },
      },
      '& .hero-title': {
        fontWeight: 'normal',
        maxWidth: 680
      },
      '& .home-hero-subtitle': {
        color: palette.text.secondary,
        fontSize: '20px',
        fontWeight: 400,
        letterSpacing: '-0.8px',
        lineHeight: '26px',
        marginBottom: '40px',
        maxWidth: 640,
      },
      '& .login-button': {
        color: palette.primary.main,
      },
      '& .header-subtitle-divider': {
        marginTop: 16,
        marginBottom: 16,
        '& .subtitle-divider': {
          width: '50%',
          background: palette.primary.main
        }
      }
    },

    /* Benefits Section - Styles */
    '& .definition-Wrapper': {
      background: palette.background.aboutBenefits,
    },
    '& #definition-section.definition-variant-1': {
      background: palette.background.aboutBenefits,
      overflow: 'hidden',
      padding: 'clamp(56px, 5vw, 96px) 0',
      position: 'relative',

      '&::after': {
        backgroundImage: "url('/images/home-images/smartyplan-monkey-small.png')",
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        content: '""',
        height: 220,
        pointerEvents: 'none',
        position: 'absolute',
        right: 'clamp(24px, 7.8125vw, 150px)',
        top: '50%',
        transform: 'translateY(-32%)',
        width: 170,
        zIndex: 0,
      },

      '& .benefits-wrapper': {
        margin: '0 auto',
        maxWidth: 1280,
        paddingRight: 210,
        position: 'relative',
        width: 'calc(100% - 96px)',
        zIndex: 1,
      },

      '& .benefits-wrapper > .MuiGrid-container': {
        flexDirection: 'column',
        gap: 32,
        margin: 0,
        width: '100%',
      },

      '& .benefits-wrapper > .MuiGrid-container > .MuiGrid-item': {
        flexBasis: '100%',
        maxWidth: '100%',
        padding: '0 !important',
      },

      '& .section-header': {
        alignItems: 'center',
        margin: 0,
      },

      '& .section-header__title-wrapper': {
        padding: '0 !important',
      },

      '& .section-header__title': {
        color: palette.text.primary,
        fontSize: 48,
        fontWeight: 400,
        letterSpacing: '-1.92px',
        lineHeight: '56px',
        maxWidth: 'none',
        padding: '0 !important',
        textAlign: 'center',
      },

      '& .section-header__subtitle-wrapper, & .section-header__cta-wrapper': {
        display: 'none',
      },

      '& .benefits-wrapper > .MuiGrid-container > .MuiGrid-item:nth-child(2) > .MuiGrid-container':
        {
          display: 'grid',
          gap: 0,
          gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
          margin: 0,
          width: '100%',
        },

      '& .service-tile-wrapper': {
        flexBasis: 'auto',
        margin: '0 !important',
        maxWidth: '100%',
        padding: '0 !important',
        position: 'relative',
      },

      '& .service-tile-wrapper:not(:last-child)::after': {
        background: palette.background.aboutBenefitsDivider,
        content: '""',
        height: 124,
        position: 'absolute',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        width: 2,
      },

      '& .definition-service-tile': {
        alignItems: 'center',
        background: 'transparent',
        border: 'none',
        boxShadow: 'none',
        flexDirection: 'column',
        gap: 0,
        height: 'auto !important',
        margin: 0,
        minHeight: 'auto !important',
        padding: '24px 28px !important',
        width: '100%',
      },

      '& .definition-service-tile > .MuiGrid-item': {
        padding: '0 !important',
      },

      '& .definition-service-tile > .MuiGrid-item:first-child': {
        alignItems: 'center',
        background: palette.text.highlight,
        borderRadius: '50%',
        display: 'flex',
        height: 72,
        justifyContent: 'center',
        width: 72,
      },

      '& .definition-service-tile > .MuiGrid-item:nth-child(2)': {
        marginTop: 24,
      },

      '& .definition-service-tile > .MuiGrid-item:nth-child(3)': {
        marginTop: 12,
      },

      '& .definition-service-tile .image, & .definition-service-tile img': {
        height: '44px !important',
        maxHeight: 44,
        maxWidth: 44,
        width: '44px !important',
      },

      '& .definition-service-title': {
        color: palette.text.primary,
        fontSize: 24,
        fontWeight: 500,
        letterSpacing: '-0.96px',
        lineHeight: '28px',
        textAlign: 'center',
      },

      '& .definition-service-description': {
        color: palette.text.body,
        fontSize: 18,
        fontWeight: 400,
        letterSpacing: '-0.54px',
        lineHeight: '24px',
        textAlign: 'center',
        whiteSpace: 'pre-line',
      },

      '@media screen and (max-width: 1200px)': {
        '&::after': {
          height: 170,
          right: 24,
          width: 130,
        },

        '& .benefits-wrapper': {
          paddingRight: 150,
        },

        '& .definition-service-tile': {
          padding: '24px 18px !important',
        },
      },

      '@media screen and (max-width: 900px)': {
        padding: '56px 24px',

        '&::after': {
          display: 'none',
        },

        '& .benefits-wrapper': {
          paddingRight: 0,
          width: '100%',
        },

        '& .benefits-wrapper > .MuiGrid-container': {
          gap: 40,
        },

        '& .section-header__title': {
          fontSize: 32,
          lineHeight: '40px',
        },

        // The four-column desktop grid wraps these to two lines on its own.
        // Below 900px the columns are wide enough to run them onto one long
        // line, so cap the measure to keep the design's two-line block.
        '& .definition-service-description': {
          marginLeft: 'auto',
          marginRight: 'auto',
          maxWidth: 260,
        },

        // Tablet keeps the four tiles as a 2x2 grid; phones stack them.
        '& .benefits-wrapper > .MuiGrid-container > .MuiGrid-item:nth-child(2) > .MuiGrid-container':
          {
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',

            '@media screen and (max-width: 600px)': {
              gridTemplateColumns: '1fr',
            },
          },

        '& .service-tile-wrapper:not(:last-child)::after': {
          bottom: -20,
          display: 'none',
          height: 2,
          left: '50%',
          right: 'auto',
          top: 'auto',
          transform: 'translateX(-50%)',
          width: 160,
        },

        '& .definition-service-tile': {
          padding: '16px 0 !important',
        },
      },
    },

    /* Membership Value - Styles */
    '& .membership-value-section': {
      '& .membership-value-title': {
        color: palette.text.title,
      },
      '& .membership-value-pretitle': {
        color: palette.background.header,
      },
      '& .membership-value-item-title': {
        color: palette.text.secondary,
      },
      '& .membership-value-subtitle, & .membership-value-item-description': {
        color: `${palette.text.secondary} !important`,
      },
      '& .membership-value-card': {
        border: `2px solid ${palette.background.aboutBenefitsBorder}`,
        borderRadius: 16,
        padding: '24px 20px',
      },
      '& .membership-value-icon-wrapper': {
        height: 44,
        minWidth: 44,
        width: 44,
      },
      '& .membership-value-column-left, & .membership-value-column-right': {
        gap: 96,
        zIndex: 3,
        '@media screen and (max-width: 1024px)': {
          gap: 40,
        },
        '@media screen and (max-width: 600px)': {
          gap: 28,
        },
      },
      '& .membership-value-content-wrapper': {
        maxWidth: 1376,
      },
      '& .membership-value-layout': {
        gridTemplateColumns: 'minmax(260px, 1fr) minmax(260px, 488px) minmax(260px, 1fr)',
        '@media screen and (max-width: 600px)': {
          gap: 28,
        },
      },
      '& .membership-value-image': {
        width: 1056,
        '@media screen and (max-width: 1024px)': {
          width: 'min(1056px, 72vw)',
        },
        '@media screen and (max-width: 600px)': {
          width: 'min(1056px, 92vw)',
        },
      },
      '& .membership-value-arrow-top-left': {
        left: 'calc(50% - 308px)',
        top: 'calc(50% - 156px)',
      },
      '& .membership-value-arrow-bottom-left': {
        left: 'calc(50% - 308px)',
        top: 'calc(50% + 31px)',
      },
      '& .membership-value-arrow-top-right': {
        left: 'calc(50% + 152px)',
        right: 'auto',
        top: 'calc(50% - 152px)',
      },
      '& .membership-value-arrow-bottom-right': {
        left: 'calc(50% + 152px)',
        right: 'auto',
        top: 'calc(50% + 34px)',
      },
    },
    '& .membership-value-wrapper': {
      background: palette.background.level1,
    },

    '& .home-partners-section': {
      '& .about-partner-card': {
        borderColor: palette.background.aboutBorder,
      },
      '& .partner-title': {
        color: palette.text.title,
      },
    },
    '& .latest-blogs-section': {
      background: palette.background.paper,
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      color: palette.text.highlight,
      minHeight: 576,
      '& .subscription-bg': {
        height: '100%',
        background: palette.background.level2,
      },
      '& .section-alternate': {
        minHeight: 576,
      },
      '& .subscription-section': {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        maxWidth: 1440,
        minHeight: 576,
        padding: '80px 80px',

        // The desktop gutter is too expensive on a tablet — it squeezed the
        // plan cards to roughly half the width they have room for.
        '@media screen and (max-width: 1024px)': {
          padding: '56px 24px',
        },
        rowGap: 56,
        width: '100%',
      },
      '& .subscription-section > .MuiBox-root': {
        alignSelf: 'stretch',
        display: 'block',
        margin: 0,
        order: 2,
        width: '100%',
      },
      '& .subscription-section .carousel-container': {
        display: 'flex',
        justifyContent: 'center',
      },
      '& .subscription-section .react-multi-carousel-track': {
        columnGap: 40,
        justifyContent: 'center',
        width: '100%',
      },
      '& .subscription-section .react-multi-carousel-item': {
        flex: '0 0 560px !important',
        width: '560px !important',
      },
      '& .subscription-section .planCard': {
        maxWidth: '560px',
        width: '560px',
      },
      '& .subscription-section .plan-carousel-item': {
        maxWidth: '560px',
        padding: 0,
        width: '100%',
      },

      '& .subscription-section--card-6': {
        '& .react-multi-carousel-item': {
          flex: '0 0 400px !important',
          width: '400px !important',

          '@media screen and (max-width: 1200px)': {
            flex: '1 1 100% !important',
            maxWidth: '100%',
            width: '100% !important',
          },
        },
        '& .planCard': {
          maxWidth: '400px',
          width: '400px',

          '@media screen and (max-width: 1200px)': {
            boxSizing: 'border-box',
            maxWidth: '100%',
            width: '100%',
          },
        },
        '& .plan-carousel-item': {
          maxWidth: '400px',

          '@media screen and (max-width: 1200px)': {
            maxWidth: '100%',
          },
        },
        '& .plan-card-v6-title-bar': {
          background: 'transparent',
          padding: '32px 24px 0',
          textAlign: 'left',
        },
        '& .plan-card-v6-title-bar .MuiTypography-root': {
          color: palette.text.title,
          fontSize: 24,
          fontWeight: 500,
          letterSpacing: '-0.96px',
          lineHeight: '28px',
        },
      },
      '& .section-header': {
        margin: 0,
        order: 1,
        width: '100%',
        '& .section-header__title-wrapper': {
          display: 'flex',
          justifyContent: 'center',
          padding: 0,
        }
      },
      '& .section-header__overline-wrapper': {
        fontSize: 24,
        fontWeight: 500,
        letterSpacing: '-0.96px',
        lineHeight: '28px',
      },
      '& .section-header__title': {
        fontSize: 56,
        fontWeight: 400,
        letterSpacing: '-2.8px',
        lineHeight: '64px',
        margin: '0 auto',
        maxWidth: 900,
        padding: 0,
        textAlign: 'center',

        '@media screen and (max-width: 1024px)': {
          fontSize: 48,
          letterSpacing: '-2.4px',
          lineHeight: '56px',
        },
      },
      '& .section-header__subtitle-wrapper': {
        padding: '20px 0 0',
      },
      '& .section-header__subtitle': {
        fontSize: 20,
        fontWeight: 400,
        letterSpacing: '-0.8px',
        lineHeight: '26px',
        margin: '0 auto',
        maxWidth: 760,
        textAlign: 'center',
      },
      '& .section-header__title, & .section-header__subtitle': {
        color: palette.text.highlight,
      },
      '& .summary-subtext': {
        alignSelf: 'center',
        background: 'none',
        color: palette.text.highlight,
        fontSize: 20,
        justifySelf: 'center',
        letterSpacing: '-0.8px',
        lineHeight: '26px',
        margin: '-56px 0 0',
        order: 4,
        padding: 0,
        textAlign: 'center',
      },
      '& .summary-subtext .savings-summary-link': {
        color: `${palette.text.highlight} !important`,
        cursor: 'pointer',
        textDecoration: 'underline !important',
      },
      '& .summary-text': {
        color: `${palette.text.highlight} !important`,
        fontSize: 20,
        fontWeight: 400,
        letterSpacing: '-0.8px',
        lineHeight: '26px',
        margin: 0,
        order: 3,
        textAlign: 'center',
        width: '100%',
      },
      '& .plan-card-variant-7': {
        '& .plan-name, & .plan-amount, & .plan-line-item-title': {
          color: palette.text.title,
        },
        '& .MuiDivider-root': {
          backgroundColor: 'transparent',
          borderTop: `1px solid ${palette.divider}`,
          height: 0,
        },
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          '& .description-cta': {
            justifyContent: 'center',
          },
          '& .description-cta__wrapper': {
            width: '100%',
          },
          '& .description-cta__innerWrapper': {
            width: '100%',
          },
          '& .description-cta__title': {
            textAlign: 'center !important',
            width: '100%',
          },
          '& .planCardHeaderContainer': {
            justifyContent: 'center',
            textAlign: 'center',
          },
          '& .customcardTitle, & .customSubscriberName': {
            textAlign: 'center',
            width: '100%',
          },
          '& .customPlanDescription': {
            textAlign: 'center',
          },
          '& .customBenefitsContainer': {
            textAlign: 'left',
          },
          '& .customBenefitsContainer > .MuiGrid-container > .MuiGrid-item:first-child': {
            textAlign: 'left',
          },
          '&:hover': {
            border: `1px solid ${palette.text.primary}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .price-value': {
            color: palette.text.primary,
            fontWeight: 'bold',
          },
          '& .customPlanDescription, & .customButtonWrapper, & .tieredPrimaryPriceItem': {
            display: 'none',
          },
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          color: palette.text.highlight,
          cursor: 'pointer',
        },
      },
      '@media screen and (max-width: 1200px)': {
        '& .subscription-section': {
          columnGap: 56,
          width: 'calc(100% - 96px)',
        },
        '& .subscription-section .carousel-container': {
          maxWidth: '100%',
          width: '100%',
        },
        '& .subscription-section .react-multi-carousel-list': {
          maxWidth: '100%',
          width: '100%',
        },
        '& .subscription-section .react-multi-carousel-item': {
          flex: '1 1 100% !important',
          maxWidth: '100%',
          width: '100% !important',
        },
        '& .subscription-section .planCard': {
          boxSizing: 'border-box',
          maxWidth: '100%',
          width: '100%',
        },
      },
      '@media screen and (min-width: 1400px)': {
        '& .subscription-section': {
          columnGap: 120,
          gridTemplateColumns: '560px minmax(0, 1fr)',
        },
      },
      '@media screen and (max-width: 768px)': { 
        '& .subscription-section': {
          display: 'flex',
          flexDirection: 'column',
          gap: 40,
          padding: '56px 24px',
          width: '100%',
        },
        '& .subscription-section .subscription-carousel-wrapper, & .subscription-section > .MuiBox-root':
          {
            width: '100%',
          },
        '& .section-header, & .section-header__title-wrapper, & .section-header__subtitle-wrapper':
          {
            justifyContent: 'center',
            textAlign: 'center',
          },
        '& .section-header__title': {
          fontSize: 32,
          fontWeight: 400,
          lineHeight: '40px',
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'center',
        },
        '& .section-header__subtitle': {
          fontSize: 16,
          lineHeight: '22px',
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'center',
        },
        '& .summary-subtext': {
          justifySelf: 'center',
          margin: '-32px auto 0',
          textAlign: 'center',
        },
        '& .summary-text': {
          fontSize: 20,
          marginTop: 0,
          textAlign: 'center',
        },
        '& .subscription-section .carousel-container': {
          boxSizing: 'border-box',
          maxWidth: '100%',
          width: '100%',
        },
        '& .subscription-section .react-multi-carousel-list, & .subscription-section .react-multi-carousel-track':
          {
            maxWidth: '100%',
            width: '100%',
          },
        '& .subscription-section .react-multi-carousel-item': {
          flex: '1 1 100% !important',
          maxWidth: '100%',
          width: '100% !important',
        },
        '& .subscription-section .carousel-single-item': {
          margin: 0,
          maxWidth: '100%',
          width: '100%',
        },
        '& .subscription-section .subscription-plan-card-item, & .subscription-section .carousel-single-item > .MuiGrid-item':
          {
            boxSizing: 'border-box',
            flexBasis: '100% !important',
            maxWidth: '100% !important',
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
          },
        '& .subscription-section .planCard': {
          boxSizing: 'border-box',
          maxWidth: '100%',
          width: '100%',
        },
        '& .subscription-section .plan-carousel-item, & .subscription-section .react-multi-carousel-item [class*="carouselItem"]':
          {
            minWidth: '0 !important',
            maxWidth: '100% !important',
            padding: '0 !important',
          },
        '& .subscription-section .planCard .customCardContent': {
          padding: '20px !important',
          '&:last-child': {
            padding: '20px !important',
          },
        },
      },
    },

    '& .benefit-strip, & .benefit-member-value, & .benefit-table, & .benefit-cta-section': {
      background: palette.background.level1,
    },

    '& .plans-card-grid': {
      alignItems: 'stretch',
    },

    '& .plans-card-combined-price': {
      columnGap: 16,
      '& .combined-price-amount': {
        fontSize: 30,
        lineHeight: '34px',
      },
      '& .combined-price-label': {
        fontSize: 13,
      },
    },

    '& .plans-card-combined-price + p, & .plan-card-v6-dependent-note, & .plan-card-v7-dependent-note': {
      background: palette.background.brandTintSoft,
      borderRadius: 8,
      color: palette.text.primary,
      padding: '12px 16px',
    },

    '& .plans-card-combined-price + p, & .plan-card-v6-dependent-note': {
      margin: '12px 0 20px',
    },

    '& a.how-it-works-hero-feature': {
      color: 'inherit',
      textDecoration: 'none',
      transition: 'border-color 0.2s ease',
      '&:hover, &:focus-visible': {
        borderColor: palette.primary.main,
      },
    },

    '& .benefit-provider-finder-embed smarty-dentist-finder': {
      background: 'transparent',
      '--primary': palette.primary.light,
      '--primary-foreground': palette.primary.contrastText,
      '--input': palette.primary.light,
    },

    '@media screen and (max-width: 1024px)': {
      '& .hero-content-side, & .how-it-works-hero-content, & .about-hero-content': {
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        textAlign: 'start',
      },

      '& .home-hero-pretitle, & .home-hero-title, & .home-hero-subtitle, & .about-hero-pretitle, & .about-hero-content h1, & .about-hero-subtitle, & .about-hero-cta': {
        textAlign: 'start',
      },

      '& .home-hero-pretitle': {
        justifyContent: 'flex-start',
      },

      '& .how-it-works-hero-feature': {
        width: '100%',
      },

      '& .checkout-flow-main-container .zipcode-filter, & .checkout-flow-main-container .zipcode-filter .zipcode-input-wrapper, & .checkout-flow-main-container .zipcode-filter + .MuiGrid-item': {
        flex: '1 1 100% !important',
        maxWidth: '100% !important',
        width: '100%',
      },

      '& .benefit-find-provider .checkout-flow-main-container .zipcode-filter .zipcode-input-wrapper': {
        paddingLeft: 0,
        paddingRight: 0,
      },

      '& .benefit-find-provider .find-provider-map-toggle': {
        marginRight: 0,
      },

      '& .benefit-find-provider .find-provider-map-toggle .MuiTypography-root': {
        whiteSpace: 'nowrap',
      },
    },

    '@media screen and (min-width: 601px) and (max-width: 1024px)': {
      '& .benefit-find-provider .checkout-flow-main-container .zipcode-filter, & .benefit-find-provider .checkout-flow-main-container .zipcode-filter + .MuiGrid-item': {
        flex: '1 1 0 !important',
        maxWidth: 'none !important',
        minWidth: 0,
        width: 'auto',
      },

      '& .benefit-find-provider .checkout-flow-main-container .zipcode-filter + .MuiGrid-item .MuiFormControl-root': {
        minWidth: 0,
        width: '100%',
      },
    },

    '@media screen and (max-width: 600px)': {
      '& .benefit-find-provider .checkout-flow-main-container .zipcode-filter, & .benefit-find-provider .checkout-flow-main-container .zipcode-filter + .MuiGrid-item': {
        marginLeft: 0,
        marginRight: 0,
        // The MFE zeroes the horizontal padding from 600px up with
        // !important, so match it to keep the fields inset at that width.
        paddingLeft: '16px !important',
        paddingRight: '16px !important',
        width: '100%',
      },

      '& .benefit-find-provider .provider-card-grid-item:has(.provider-card-title)': {
        order: 1,
      },

      '& .benefit-find-provider .provider-card-grid-item:has(.provider-card-detail)': {
        order: 2,
      },

      '& .benefit-find-provider .provider-card-grid-item:has(.provider-card-actions)': {
        order: 3,
      },
    },

    '@media screen and (min-width: 1025px)': {
      '& .benefit-hero': {
        paddingLeft: 80,
        paddingRight: 80,
      },

      '& .benefit-cta-band': {
        margin: '0 auto',
        maxWidth: 1280,
      },

      '& .app-main-content:has(.benefit-hero--dental) .howitworks-cards-wrapper': {
        paddingLeft: 0,
        paddingRight: 0,
      },

      '& .how-it-works-hero-section': {
        paddingLeft: 80,
        paddingRight: 80,
      },

      '& .how-it-works-hero-wrapper': {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 1440,
        padding: '0 32px 0 56px',
      },

      '& .home-hero-wrapper.home-hero-variant-3': {
        paddingLeft: 'max(80px, calc(50% - 720px))',
        paddingRight: 'max(80px, calc(50% - 720px))',

        '& .hero-content-side': {
          paddingLeft: 56,
        },
      },

      '& .home-partners-section .partners-section-wrapper, & .faq-variant3-wrapper': {
        paddingLeft: 56,
        paddingRight: 56,
      },

      '& .about-benefits-section, & .about-mission-section, & .about-partners-section, & .about-service-section, & .about-info-section, & .about-cta-section, & .about-page .howitworks-cards-section > .section': {
        paddingLeft: 136,
        paddingRight: 136,
      },

      '& .about-page .howitworks-cards-wrapper': {
        paddingLeft: 0,
        paddingRight: 0,
      },

      '& .app-main-content .about-page .about-hero-section': {
        paddingLeft: 80,
        paddingRight: 80,
      },

      '& .app-main-content .about-page .about-hero-section .about-hero-wrapper': {
        paddingLeft: 56,
        paddingRight: 32,
      },

      '& .how-it-works-benefit-row, & .how-it-works-love-panel': {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 1360,
      },

      '& .how-it-works-page .howitworks-cards-wrapper': {
        maxWidth: 1440,
      },

      '& .benefit-table-scroll': {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 1280,
      },

      '& .about-benefits-wrapper, & .about-mission-wrapper, & .partners-section-wrapper, & .about-service-wrapper, & .about-info-wrapper, & .about-cta-band, & .about-page .howitworks-cards-wrapper, & .faq-variant3-wrapper': {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 1440,
      },

      '& .about-benefits-wrapper, & .about-mission-wrapper, & .about-partners-section .partners-section-wrapper, & .about-service-wrapper, & .about-info-wrapper, & .about-cta-band, & .about-page .howitworks-cards-wrapper': {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 1328,
      },
    },

    '& .benefit-hero--vision .benefit-hero-card-value--large': {
      fontSize: 20,
      letterSpacing: '-0.4px',
      lineHeight: '26px',
    },

    /* How it works (card variant) - Styles */
    '& .benefit-howitworks': {
      '& .howitworks-card': {
        border: `1px solid ${palette.background.aboutBenefits}`,
      },

      '& .howitworks-step-counter': {
        background: palette.background.aboutPartnerIconBanner,
        color: palette.background.level2,
      },

      '& .howitworks-step-title': {
        color: palette.text.title,
      },

      '& .howitworks-step-bullet': {
        color: palette.text.title,
      },

      '@media screen and (max-width: 1200px)': {
        '& .howitworks-card': {
          columnGap: 32,
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.level1,

      '& .howitworks-wrapper': {
        maxWidth: 1280,
        margin: '0 auto',
        padding: 0,
      },

      '& .howitworks-wrapper-left': {
        padding: '0 !important',
      },

      '& .how-cover-image': {
        backgroundSize: 'contain',
        display: 'block',
        height: 640,
        margin: '0 auto',
        maxWidth: 600,
        objectFit: 'contain',
        width: '100%',
      },

      '& .howitworks-grid': {
        alignItems: 'center',
        columnGap: 120,
        flexWrap: 'nowrap',
        margin: 0,
        width: '100%',
      },

      '& .howitworks-grid > .howitworks-wrapper-left, & .howitworks-grid > .cover-image-wrapper, & .howitworks-grid > .MuiGrid-item':
        {
          flexBasis: 'auto',
          maxWidth: 'none',
          padding: '0 !important',
        },

      '& .howitworks-grid > .howitworks-wrapper-left': {
        flex: '1 1 0',
        minWidth: 0,
      },

      '& .howitworks-content-grid, & .howitworks-wrapper-left > .MuiGrid-container': {
        margin: 0,
        width: '100%',
      },

      '& .howitworks-content-grid > .MuiGrid-item, & .howitworks-wrapper-left > .MuiGrid-container > .MuiGrid-item':
        {
          paddingLeft: '0 !important',
          paddingRight: '0 !important',
        },

      '& .howitworks-grid > .cover-image-wrapper': {
        flex: '0 0 600px',
        maxWidth: 600,
        minWidth: 600,
      },

      '& .howitworks-title': {
        marginBottom: 40,
        padding: '0 !important',
      },

      '& .howitworks-title .section-header': {
        gap: 12,
      },

      '& .howitworks-title .section-header__overline-wrapper': {
        color: palette.primary.main,
        fontSize: 24,
        fontWeight: 500,
        letterSpacing: '-0.96px',
        lineHeight: '28px',
        padding: '0 !important',
        textTransform: 'uppercase',
      },

      '& .howitworks-title .section-header__title-wrapper, & .howitworks-title .section-header__subtitle-wrapper':
        {
          padding: '0 !important',
        },

      '& .howitworks-title .section-header__title': {
        color: palette.text.heading,
        fontSize: 36,
        fontWeight: 400,
        letterSpacing: '-1.44px',
        lineHeight: '40px',
        maxWidth: 500,
        padding: '0 !important',
      },

      '& .howitworks-title .section-header__subtitle': {
        color: palette.text.body,
        fontSize: 20,
        fontWeight: 400,
        letterSpacing: '-0.8px',
        lineHeight: '26px',
        maxWidth: 560,
      },

      '& .working-steps-main-container': {
        padding: '0 !important',
      },

      '& .working-steps-container': {
        margin: '0 !important',
        padding: '24px 0',
        position: 'relative',
      },

      '& .working-steps-container:first-child': {
        paddingTop: 0,
      },

      '& .working-steps-container:not(:last-child)': {
        borderBottom: `1px solid ${palette.text.border}`,
      },

      '& .working-steps-container .step-counter-item, & .working-steps-container .step-content-item, & .working-steps-container > .MuiGrid-item':
        {
          padding: '0 !important',
        },

      '& .working-steps-container .step-content-item, & .working-steps-container > .MuiGrid-item:nth-child(2)':
        {
          paddingLeft: '24px !important',
        },

      '& .step-counter': {
        alignItems: 'center',
        backgroundColor: palette.primary.main,
        borderRadius: '50%',
        color: palette.text.highlight,
        display: 'inline-flex',
        fontSize: 14,
        fontWeight: 500,
        height: 40,
        justifyContent: 'center',
        letterSpacing: '-0.28px',
        lineHeight: '20px',
        minWidth: 40,
        width: 40,
      },

      '& .step-title': {
        color: palette.text.heading,
        fontSize: 24,
        fontWeight: 500,
        letterSpacing: '-0.48px',
        lineHeight: '28px',
        marginBottom: 10,
      },

      '& .step-content': {
        color: palette.text.body,
        fontSize: 16,
        fontWeight: 400,
        letterSpacing: '-0.64px',
        lineHeight: '22px',
        maxWidth: 520,
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '@media screen and (min-width: 900px) and (max-width: 1200px)': {
        padding: '72px 48px',

        '& .howitworks-grid': {
          columnGap: 48,
        },

        '& .howitworks-grid > .cover-image-wrapper': {
          flex: '0 0 44%',
          maxWidth: '44%',
          minWidth: 0,
        },

        '& .howitworks-grid > .howitworks-wrapper-left': {
          flex: '1 1 0',
        },

        '& .how-cover-image': {
          height: 'auto',
          maxHeight: 520,
          maxWidth: '100%',
        },

        '& .howitworks-title .section-header__title': {
          fontSize: 36,
          letterSpacing: '-1.44px',
          lineHeight: '40px',
          maxWidth: 420,
        },

        '& .howitworks-title .section-header__subtitle': {
          fontSize: 18,
          lineHeight: '24px',
          maxWidth: 420,
        },
      },

      '@media screen and (max-width: 900px)': {
        boxSizing: 'border-box',
        overflowX: 'hidden',
        padding: '56px 24px',

        '& .section': {
          paddingLeft: '0 !important',
          paddingRight: '0 !important',
        },

        '& .howitworks-wrapper': {
          maxWidth: '100%',
          width: '100%',
        },

        '& .howitworks-grid, & .howitworks-content-grid, & .howitworks-wrapper-left > .MuiGrid-container, & .working-steps-container':
          {
            margin: '0 !important',
            maxWidth: '100% !important',
            width: '100% !important',
          },

        '& .howitworks-content-grid > .MuiGrid-item, & .howitworks-wrapper-left > .MuiGrid-container > .MuiGrid-item, & .howitworks-grid > .howitworks-wrapper-left, & .howitworks-grid > .cover-image-wrapper, & .howitworks-grid > .MuiGrid-item':
          {
            maxWidth: '100%',
            padding: '0 !important',
          },

        '& .working-steps-main-container': {
          maxWidth: '100%',
          width: '100%',
        },

        '& .working-steps-container': {
          boxSizing: 'border-box',
          maxWidth: '100%',
          width: '100%',
        },

        '& .working-steps-container .step-counter-item, & .working-steps-container .step-content-item, & .working-steps-container > .MuiGrid-item':
          {
            minWidth: 0,
            padding: '0 !important',
          },

        '& .working-steps-container .step-content-item, & .working-steps-container > .MuiGrid-item:nth-child(2)':
          {
            flex: '1 1 0',
            maxWidth: 'calc(100% - 40px)',
            paddingLeft: '16px !important',
          },

        '& .step-title, & .step-content': {
          maxWidth: '100%',
          overflowWrap: 'break-word',
          wordBreak: 'break-word',
        },

        '& .howitworks-grid': {
          flexWrap: 'wrap',
          rowGap: 40,

          '@media screen and (max-width: 600px)': {
            flexDirection: 'column',
          },
        },

        '& .howitworks-grid > .howitworks-wrapper-left, & .howitworks-grid > .cover-image-wrapper, & .howitworks-grid > .MuiGrid-item':
          {
            flexBasis: '100%',
            maxWidth: '100%',
          },

        '& .howitworks-grid > .cover-image-wrapper': {
          flex: '0 0 100%',
          maxWidth: '100%',
          minWidth: 0,
          overflow: 'hidden',
        },

        '& .howitworks-wrapper-left': {
          padding: '0 !important',
        },

        '& .how-cover-image': {
          height: 'auto',
          maxHeight: 520,
          maxWidth: '100%',
        },

        '& .howitworks-title .section-header__title': {
          fontSize: 32,
          letterSpacing: '-1px',
          lineHeight: '40px',
        },

        '& .howitworks-title .section-header': {
          margin: '0 !important',
          maxWidth: '100%',
          width: '100%',
        },

        '& .howitworks-title .section-header > .MuiGrid-item': {
          padding: '0 !important',
        },

        '& .howitworks-title .section-header__subtitle': {
          maxWidth: '100%',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '100px',
        },
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      backgroundImage: `url(${testimonialBg})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      '& .testimonial-message': {
        color: palette.text.body,
        fontWeight: 300,
      },
      '& .react-multi-carousel-dot button': {
        background: palette.primary.main,
      },
    },

    /* FAQ Section */
    '& .FAQSection': {
      padding: '96px 0',
      position: 'relative',
      maxWidth: 'none !important',
      width: '100%',
      background: palette.background.aboutFaq,

      '& .faq-variant2-wrapper': {
        margin: '0 auto',
        maxWidth: 1280,
        padding: '0 112px',
        width: 'calc(100% - 96px)',
      },

      '& .faq-variant2-wrapper > .MuiGrid-container': {
        flexDirection: 'column',
        gap: 56,
        margin: 0,
        width: '100%',
      },

      '& .faq-variant2-wrapper > .MuiGrid-container > .MuiGrid-item': {
        flexBasis: '100%',
        maxWidth: '100%',
        padding: '0 !important',
        width: '100%',
      },

      '& .section-header': {
        alignItems: 'center',
        margin: 0,
      },

      '& .section-header__overline-wrapper': {
        display: 'none',
      },

      '& .section-header__title-wrapper': {
        padding: '0 !important',
      },

      '& .section-header__title': {
        color: palette.text.primary,
        fontSize: 48,
        fontWeight: 400,
        letterSpacing: '-1.92px',
        lineHeight: '56px',
        padding: '0 !important',
        textAlign: 'center',
      },

      '& .faq-variant2-wrapper .accordion': {
        gap: 24,
      },

      '& .faq-variant2-wrapper .MuiAccordion-root': {
        background: palette.text.highlight,
      },

      '& .accordion__item-wrapper': {
        border: `1px solid ${palette.text.border}`,
        borderRadius: '8px !important',
        boxShadow: 'none',
        margin: '0 !important',
        overflow: 'hidden',
        padding: 0,
      },

      '& .accordion__item-wrapper::before': {
        display: 'none',
      },

      '& .accordion__item-wrapper .MuiAccordionSummary-root': {
        minHeight: 72,
        padding: '0 24px',
      },

      '& .accordion__item-wrapper .MuiAccordionSummary-root.Mui-expanded': {
        minHeight: 72,
      },

      '& .accordion__item-wrapper .MuiAccordionSummary-content': {
        margin: '0 !important',
      },

      '& .accordion__item-wrapper .MuiAccordionSummary-expandIcon': {
        padding: 0,
      },

      '& .accordion__item-wrapper .expandIcon, & .accordion__item-wrapper .collapseIcon':
        {
          color: `${palette.primary.main} !important`,
          fontSize: 24,
        },

      '& .accorion_item-title, & .accorion__item-title-container .MuiTypography-root':
        {
        color: `${palette.text.primary} !important`,
        fontSize: 18,
        fontWeight: '500 !important',
        letterSpacing: '-0.72px',
        lineHeight: '24px',
      },

      '& .accordion__item-wrapper.Mui-expanded .accorion_item-title, & .accordion__item-wrapper.Mui-expanded .accorion__item-title-container .MuiTypography-root':
        {
        color: `${palette.primary.main} !important`,
      },

      '& .accordion__item-wrapper .MuiAccordionDetails-root': {
        padding: '0 88px 24px 24px',
      },

      '& .accordion__collapsable-text-container': {
        margin: 0,
        width: '100%',
      },

      '& .accordion__collapsable-text-wrapper': {
        padding: '0 !important',
      },

      '& .accordion__collapsable-text': {
        color: palette.text.body,
        fontSize: 14,
        fontWeight: 400,
        letterSpacing: '-0.28px',
        lineHeight: '18px',
      },

      '@media screen and (max-width: 1200px)': {
        '& .faq-variant2-wrapper': {
          padding: '0 48px',
          width: 'calc(100% - 48px)',
        },
      },

      '@media screen and (max-width: 900px)': {
        padding: '56px 24px',

        '& .faq-variant2-wrapper': {
          padding: 0,
          width: '100%',
        },

        '& .faq-variant2-wrapper > .MuiGrid-container': {
          gap: 40,
        },

        '& .section-header__title': {
          fontSize: 32,
          lineHeight: '40px',
        },

        '& .accordion__item-wrapper .MuiAccordionSummary-root': {
          padding: '0 18px',
        },

        '& .accordion__item-wrapper .MuiAccordionDetails-root': {
          padding: '0 18px 18px',
        },
      },
    },

    '& .dashboard-main-container .dashboard-have-questions-section .MuiPaper-root.widget':
      {
        background: `linear-gradient(90deg, ${palette.background.aboutBenefitsOverlay} 0%, ${palette.background.aboutBenefitsOverlay} 100%), linear-gradient(90deg, ${palette.background.questions} 0%, ${palette.background.questions} 100%)`,
        border: `1px solid ${palette.primary.main}`,
        borderRadius: 20,
        color: palette.text.questions,
        padding: '32px 24px',
        paddingBottom: 55,

        '& .MuiTypography-h5': {
          color: palette.text.questions,
          fontSize: 20,
          fontWeight: 500,
          letterSpacing: '0.75px',
          lineHeight: '28px',
          marginBottom: 4,
        },

        '& .MuiTypography-body1': {
          color: palette.text.body,
          fontSize: 18,
          fontWeight: 400,
          letterSpacing: '-0.54px',
          lineHeight: '24px',
        },

        '& .MuiTypography-subtitle1, & .MuiListItemText-primary .MuiTypography-root':
          {
            color: `${palette.text.questions} !important`,
            fontSize: 16,
            fontWeight: 400,
            letterSpacing: '-0.64px',
            lineHeight: '22px',
          },

        '& .MuiListItem-root': {
          padding: '8px 0',
        },

        '& .MuiListItemAvatar-root': {
          minWidth: 36,
        },

        '& .MuiSvgIcon-root': {
          color: `${palette.primary.main} !important`,
          fontSize: 28,
        },

        '& .MuiDivider-root': {
          backgroundColor: palette.background.questionsDivider,
          margin: '20px 0',
        },

        '& .dashboard-have-questions-footer .MuiTypography-root': {
          color: palette.text.primary,
          fontSize: 16,
          fontWeight: 400,
          letterSpacing: '-0.64px',
          lineHeight: '22px',
        },

        '& .dashboard-have-questions-footer .MuiLink-root': {
          color: `${palette.primary.main} !important`,
        },

        '& .dashboard-have-questions-footer + .dashboard-have-questions-footer': {
          marginTop: '12px !important',
        },

        '& .MuiListItemText-root .MuiLink-root': {
          color: `${palette.text.questions} !important`,
          textDecoration: 'none',
        },
      },
    '& .dashboard-main-container .dashboard-subscription-details-section .MuiPaper-root.widget .description-cta, & .dashboard-main-container .dashboard-benefits-usage-section .MuiPaper-root.benefits-widget .description-cta':
      {
        backgroundColor: `${palette.background.paper} !important`,
        borderBottomColor: palette.text.border,
      },
    '& .dashboard-main-container .dashboard-subscription-details-section .description-cta, & .dashboard-main-container .dashboard-payment-details-section .description-cta, & .dashboard-main-container .dashboard-benefits-usage-section .description-cta, & .dashboard-main-container .dashboard-subscription-details-section [class*="titleCont"], & .dashboard-main-container .dashboard-payment-details-section [class*="titleCont"], & .dashboard-main-container .dashboard-benefits-usage-section [class*="titleCont"]':
      {
        backgroundColor: `${palette.background.paper} !important`,
        borderBottomColor: palette.text.border,
      },
    '& .dashboard-main-container .dashboard-benefits-usage-section .MuiPaper-root.benefits-widget .benefits-done-wrappper':
      {
        background: `transparent url(${YesIcon}) center / contain no-repeat`,
      },
    '& .dashboard-main-container .dashboard-benefits-usage-section .MuiPaper-root.benefits-widget .benefits-done-icon':
      {
        opacity: 0,
      },

    '@media screen and (max-width: 1200px)': {
      '& .FAQSection::after': {
        height: '34vw',
        width: '47vw',
      },
    },

    '@media screen and (max-width: 900px)': {
      '& .FAQSection::after': {
        display: 'none',
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        background: palette.background.alternate,
        marginBottom: 0,

        '& .section': {
          padding: '80px 32px !important',
        },

        '& .hero-header-title': {
          color: `${palette.text.highlight} !important`,
          fontSize: 36,
          fontWeight: 400,
          letterSpacing: '-1.44px',
          lineHeight: '40px',
        },

        '& .hero-header-subtitle': {
          color: `${palette.text.highlight} !important`,
          fontSize: 18,
          fontWeight: 400,
          letterSpacing: '-0.54px',
          lineHeight: '24px',
        },
      },
      '& .section-header': {
        '& .section-header__title': {
          color: `${palette.text.heading} !important`,
          fontSize: 36,
          fontWeight: 400,
          letterSpacing: '-1.44px',
          lineHeight: '40px',
        },
        '& .section-header__subtitle': {
          color: `${palette.text.body} !important`,
          fontSize: 18,
          fontWeight: 400,
          letterSpacing: '-0.54px',
          lineHeight: '24px',
        },
      },
      '& .savings-hero-section .hero-home-button': {
        background: 'transparent',
        border: `1px solid ${palette.text.highlight}`,
        borderRadius: 12,
        color: `${palette.text.highlight} !important`,
        fontSize: 16,
        fontWeight: 400,
        letterSpacing: '-0.32px',
        lineHeight: '20px',
        minWidth: 144,
        padding: '12px 24px',

        '&:hover': {
          background: 'rgba(255, 255, 255, 0.12)',
          border: `1px solid ${palette.text.highlight}`,
          color: `${palette.text.highlight} !important`,
        },
      },
      '& .service-plan-table': {
        borderColor: `${palette.background.tableHead} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
          borderTop: 'none !important',
          borderBottom: 'none !important',
          borderLeft: 'none !important',
          '&:not(:last-child)': {
            borderRight: `1px solid ${palette.text.highlight} !important`,
          },
        },

        '& .savings-header': {
          color: palette.text.body,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .view-more-button': {
        background: palette.background.alternate,
        borderColor: palette.background.alternate,
        color: palette.text.highlight,

        '&:hover': {
          background: palette.primary.main,
          borderColor: palette.primary.main,
          color: palette.text.highlight,
        },
      },

      '& .savings-contact-card': {
        background: palette.text.highlight,

        '@media screen and (max-width: 900px)': {
          marginTop: '0 !important',
          padding: '0 !important',

          '& .section-header, & .section-header__title-wrapper, & .section-header__subtitle-wrapper':
            {
              justifyContent: 'center',
              textAlign: 'center',
            },

          '& .contact-card-title, & .contact-card-subtitle, & .section-header__title, & .section-header__subtitle':
            {
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'center !important',
            },

          '& .contact-card-subtitle': {
            maxWidth: '100%',
          },
        },
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.text.highlight,
      },
      '& .section-header__subtitle': {
        color: palette.text.body,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Subscription success */
    '& .cancel-button.MuiButton-outlinedPrimary': {
      color: palette.primary.main,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        background: palette.background.light,
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.background.brandTint}`,
          '& .price-value, .display-frequency': {
            color: palette.secondary.main,
          },
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.highlight,
          },
        },
        '& .plan-card-v6-title-bar': {
          background: 'transparent',
          padding: '32px 24px 0',
          textAlign: 'left',
        },
        '& .plan-card-v6-title-bar .MuiTypography-root': {
          color: palette.text.title,
          fontSize: 24,
          fontWeight: 500,
          letterSpacing: '-0.96px',
          lineHeight: '28px',
        },
      },
      '& .primary-static-button': {
        background: palette.primary.main,
      },
      '& .react-multi-carousel-dot button': {
        background: palette.primary.main,
      },
      '& .card-product, & .details-root': {
        display: 'none',
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      backgroundImage: `url(${background})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',

      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        textAlign: 'left',
      },
      '& .hero-header-subtitle': {
        color: `${palette.text.body} !important`,
      },
      '& .header-container': {
        justifyContent: 'left',
        margin: '0',
      },
      '& .section': {
        marginLeft: 64,
        '@media(max-width: 900px)': {
          marginLeft: 0,
        },
      },
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: palette.text.body,
      },
      '& .faq-link': {
        fontWeight: 500,
      },
    },
    '& .faq-contact-section': {
      background: palette.text.highlight,
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-subtitle': {
        color: palette.text.body,
      },
      '& .provider-contact-details': {
        fontWeight: 500,
        color: palette.text.body,
      },
      '& .provider-contact-link': {
        color: palette.text.primary,
      },
      '@media screen and (max-width: 900px)': {
        padding: '40px 24px !important',

        '& .section-header, & .section-header__title-wrapper, & .section-header__subtitle-wrapper':
          {
            justifyContent: 'center',
            textAlign: 'center',
          },

        '& .contact-card-title, & .contact-card-subtitle, & .section-header__title, & .section-header__subtitle':
          {
            marginLeft: 'auto',
            marginRight: 'auto',
            textAlign: 'center !important',
          },

        '& .contact-card-subtitle': {
          maxWidth: '100%',
        },
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'auto',
        fontWeight: 'bold',
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.text.highlight,
      '& .faq-contact-section': {
        paddingBottom: 96,
        paddingTop: 96,
      },
      '& .contact-card-title': {
        color: palette.text.title,
        fontWeight: 400,
        fontSize: 36,
        letterSpacing: '-1.44px',
        lineHeight: '40px',
        '@media screen and (max-width: 768px)': {
          fontSize: 28,
          lineHeight: '34px',
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.body,
        fontSize: 20,
        fontWeight: 400,
        letterSpacing: '-0.8px',
        lineHeight: '26px',
        '@media screen and (max-width: 768px)': {
          fontSize: 16,
          lineHeight: '22px',
        },
      },
      '& .provider-contact-details': {
        color: palette.text.body,
        fontSize: 16,
        fontWeight: 400,
        letterSpacing: '-0.32px',
        lineHeight: '18px',
        marginBottom: 8,
      },

      '& .section-header': {
        marginBottom: 48,
      },

      '& .section-header__subtitle-wrapper': {
        paddingTop: 0,
      },

      '& .contact-img-wrapper': {
        maxWidth: 56,
        minWidth: 56,
        width: 56,

        '& img': {
          display: 'block',
          height: 56,
          width: 56,
        },
      },

      '& .contact-img-wrapper + .MuiGrid-item': {
        paddingLeft: 20,
      },

      '& .contact-items-row .MuiDivider-root': {
        background: palette.background.aboutContactDivider,
      },

      '@media screen and (min-width: 960px)': {
        '& .contact-items-row': {
          alignItems: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 48,
          justifyContent: 'center',
          margin: 0,
          width: '100%',

          '& > .MuiGrid-item': {
            padding: 0,
          },
        },
      },

      // Below 1020 the three values only fit on one row at a smaller scale,
      // so step the icon and the value down rather than let them wrap.
      '@media screen and (min-width: 750px) and (max-width: 1019px)': {
        '& .contact-items-row .contact-img-wrapper': {
          maxWidth: 48,
          minWidth: 48,
          width: 48,

          '& img': {
            height: 48,
            width: 48,
          },
        },

        '& .contact-items-row .contact-img-wrapper + .MuiGrid-item': {
          paddingLeft: 12,
        },

        '& .contact-items-row .provider-contact-link': {
          fontSize: 18,
          lineHeight: '24px',
        },

        '& .contact-items-row .provider-contact-details': {
          fontSize: 15,
        },
      },

      // Between 1020 and the desktop layout the three items only just fit, so
      // trim the gutters to keep them on one row with their values unwrapped.
      '@media screen and (min-width: 1020px) and (max-width: 1199px)': {
        '& .contact-items-row': {
          gap: 24,
        },
      },

      '& .provider-contact-link': {
        color: palette.text.title,
        fontSize: 20,
        fontWeight: 500,
        letterSpacing: '-0.4px',
        lineHeight: '26px',
      },
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* About Page - Styles */
    '& .about-page': {
      marginTop: 0,

      '& .howitworks-card': {
        columnGap: 80,
      },

      '& .about-cta-primary': {
        background: palette.background.alternate,
      },

      '& .about-cta-secondary': {
        borderColor: palette.background.alternate,
        color: palette.background.alternate,
      },

      '& .about-cta-title span': {
        color: palette.background.alternate,
      },


      '& .about-hero-section': {
        background: `linear-gradient(90deg, ${palette.background.aboutHeroOverlay} 0%, ${palette.background.aboutHeroOverlay} 100%), ${palette.background.paper}`,
        padding: 0,

        '& .about-hero-wrapper, & > .MuiBox-root': {
          maxWidth: 1440,
          width: '100%',
          margin: '0 auto',
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 80,
          paddingRight: 64,

          // Only at the widest layout does the hero content sit short enough
          // inside the 640px min-height for the centring to leave room above
          // it. Below that it fills the wrapper and starts hard against the
          // header, so give it explicit room.
          '@media screen and (max-width: 1199px)': {
            paddingTop: 48,
            paddingBottom: 48,
          },

          '@media screen and (max-width: 600px)': {
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 32,
            paddingBottom: 32,
          },
        },

        '@media screen and (max-width: 900px)': {
          '& .about-hero-content, & > .MuiBox-root > .MuiBox-root:first-of-type':
            {
              marginLeft: 0,
              marginRight: 'auto',
              maxWidth: '100%',
              textAlign: 'start',
            },

          '& .about-hero-pretitle, & > .MuiBox-root > .MuiBox-root:first-of-type > p:first-of-type, & .about-hero-content h1, & h1, & .about-hero-subtitle, & h1 + p':
            {
              marginLeft: 0,
              marginRight: 'auto',
              textAlign: 'start',
            },

          '& .about-hero-subtitle, & h1 + p': {
            maxWidth: '100%',
          },

          '& .about-hero-cta, & > .MuiBox-root > .MuiBox-root:first-of-type > .MuiBox-root:last-of-type':
            {
              justifyContent: 'flex-start',
              marginTop: '40px !important',
            },
        },

        '& .about-hero-content, & > .MuiBox-root > .MuiBox-root:first-of-type': {
          maxWidth: 640,
        },

        '& .about-hero-pretitle, & > .MuiBox-root > .MuiBox-root:first-of-type > p:first-of-type':
          {
            color: palette.primary.main,
            fontSize: '24px',
            fontWeight: 500,
            letterSpacing: '-0.96px',
            lineHeight: '28px',
            margin: '0 0 40px !important',
          },

        '& h1': {
          color: palette.text.primary,
          fontSize: '64px',
          fontWeight: 400,
          letterSpacing: '-3.2px',
          lineHeight: '72px',
          margin: '0 0 40px !important',

          '@media screen and (max-width: 768px)': {
            fontSize: '40px',
            letterSpacing: '-1.6px',
            lineHeight: '48px',
          },
        },

        '& h1 span': {
          color: palette.primary.main,
          fontWeight: 'inherit',
        },

        '& .about-hero-subtitle, & h1 + p': {
          color: palette.text.secondary,
          fontSize: '20px',
          fontWeight: 400,
          letterSpacing: '-0.8px',
          lineHeight: '26px',
          margin: '0 0 40px !important',
          maxWidth: 640,
        },

        '& .about-hero-cta, & > .MuiBox-root > .MuiBox-root:first-of-type > .MuiBox-root:last-of-type':
          {
            gap: 16,
            marginTop: '90px !important',
          },

        '& .MuiButton-root': {
          borderRadius: 12,
          fontSize: '16px !important',
          fontWeight: 400,
          letterSpacing: '-0.32px',
          lineHeight: '20px',
          padding: '12px 24px !important',
        },

        '& .MuiButton-outlinedPrimary': {
          color: palette.primary.main,
        },
      },
    },
    '& .about-benefits-section': {
      background: palette.background.level1,
      paddingTop: 0,

      '& .about-benefits-grid': {
        background: palette.background.paper,
        border: `1px solid ${palette.text.border}`,
        borderRadius: 24,
        padding: '40px 0',
      },
    },
    '& .about-partners-section, & .dashboard-partners-section': {
      '& .about-partner-card': {
        borderColor: palette.background.aboutBorder,
      },

      '& h2 + p': {
        color: `${palette.text.body} !important`,
      },

      '& .about-partner-card h3 + p': {
        color: `${palette.text.body} !important`,
      },
    },
    '& .about-partners-section': {
      background: palette.background.aboutPartners,

      '& .partners-section-pretitle': {
        color: palette.text.title,
        fontSize: 18,
        fontWeight: 500,
        letterSpacing: '-0.36px',
        lineHeight: '24px',
        textTransform: 'none',
      },

      '& .partners-section-subtitle': {
        color: `${palette.text.title} !important`,
        paddingBottom: 24,
        position: 'relative',

        '&::after': {
          background: palette.primary.main,
          borderRadius: 2,
          bottom: 0,
          content: '""',
          height: 4,
          left: '50%',
          position: 'absolute',
          transform: 'translateX(-50%)',
          width: 210,
        },
      },
    },
    '& .dashboard-partners-section': {
      padding: 0,
      background: `${palette.background.paper} !important`,

      '& .partners-section-wrapper': {
        margin: 0,
        maxWidth: 'none',
        gap: 16,
      },

      '& .partners-section-header': {
        alignItems: 'flex-start',
        margin: 0,
        maxWidth: 'none',
        textAlign: 'left',

        '& h2': {
          fontSize: 20,
          fontWeight: 500,
          letterSpacing: '0.75px',
          lineHeight: '28px',
        },
      },
    },
    '& .about-how-it-works-section': {
      background: palette.background.aboutHowItWorks,

      '& .about-how-it-works-pretitle': {
        fontSize: 24,
        fontWeight: 500,
        letterSpacing: '-0.96px',
        lineHeight: '28px',
      },

      '& .about-how-it-works-title': {
        color: palette.text.heading,
        fontSize: 36,
        fontWeight: 400,
        letterSpacing: '-1.44px',
        lineHeight: '40px',
      },

      '@media screen and (max-width: 900px)': {
        '& .about-how-it-works-title': {
          fontSize: 32,
          letterSpacing: '-1px',
          lineHeight: '40px',
        },
      },
    },
    '& .about-step-item:not(:last-child)': {
      borderBottom: `1px solid ${palette.background.aboutStepDivider}`,
    },
    '& .about-faq-section': {
      background: palette.background.aboutFaq,

      '& .accordion__item-wrapper': {
        border: `1px solid ${palette.background.aboutBorder}`,
      },
    },

    '@media screen and (min-width: 901px)': {
      '& .home-partners-section, & .FAQVariant3Section': {
        paddingLeft: 80,
        paddingRight: 80,
      },

      '& .plans-page .FAQVariant3Section': {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },

    '@media screen and (min-width: 901px) and (max-width: 1024px)': {
      '& .faq-variant3-wrapper, & .about-page .howitworks-cards-wrapper': {
        paddingLeft: 0,
        paddingRight: 0,
      },

      '& .about-benefits-section, & .about-mission-section, & .about-partners-section, & .about-service-section, & .about-info-section, & .about-cta-section, & .about-page .howitworks-cards-section > .section': {
        paddingLeft: 80,
        paddingRight: 80,
      },
    },

    '& .faq-variant3-accordion-wrapper--no-tabs': {
      marginTop: 40,
    },

    /* Footer Style */
    '& .footer-wrapper': {
      background: palette.background.footer
    },

    '& .MuiTypography-colorTextSecondary': {
      color: palette.text.body,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.alternate,
      },
      '& .stepperIconActive': {
        color: `${palette.primary.main} !important`,
        '& .stepperIconText': {
          fill: palette.text.highlight,
        },
      },
      '& .stepperIconRoot': {
        color: 'transparent',
        borderColor: palette.primary.main,
        '& .stepperIconText': {
          fill: palette.primary.main,
        },
      },
      '& .stepperIconCompleted': {
        color: palette.primary.main,
      },
    },
  },
};
